import { Controller } from "stimulus"
import { contactTemplate, facilitatorTemplate } from '../../js/guestlist_templates';
import { getOrdinalSuffix, getWeekOfTheMonth } from '../../js/date_helpers';
import { RRule } from 'rrule';
import { DataTable } from "simple-datatables";
export default class extends Controller {
  static targets = ["contactList", "facilitatorList", "form", "submit", "title", "timePicker", "startDate", "duration", "frequency", "contacts"]

  initialize() {
    if (document.getElementById('createScheduledSessionForm')) {
      this.cache_scheduled_session = JSON.parse(sessionStorage.getItem('cache_scheduled_session')) || {};
      this.contacts = this.cache_scheduled_session.contacts || []
      this.facilitators = this.cache_scheduled_session.facilitators || [];
      this.timezone = document.getElementById('javascript_variables').dataset.timezone;
      // Setup form
      this.setModalInputsAutofocus();
      this.setTimePickerOptions();
      this.setFrequencyOptions();
      // Fill cached values
      this.setContactsAndFacilitator();
      this.setCachedFormValues();
      // validations
      this.createScheduledSessionForm = this.createScheduledSessionForm();
      // Setup add guest and facilitator modals
      this.guestDataTable = new DataTable("#addGuestTable", {
        perPage: 100,
        perPageSelect: false,
        labels: {
          noRows: "No contacts found",
          info: "Showing {start} to {end} of {rows} contacts"
        }
      });
      this.facilitatorDataTable = new DataTable("#addFacilitatorTable", {
        perPage: 100,
        perPageSelect: false,
        labels: {
          noRows: "No contacts found",
          info: "Showing {start} to {end} of {rows} contacts"
        }
      });
      this.setupDataTableSearch();
      this.addGuestJoiningOptionsEventListener();
      this.addFacilitatorJoiningOptionsEventListener();
    }
  }

  setupDataTableSearch() {
    let facilitatorSearchBar = document.getElementById('addFacilitatorSearchBar');
    facilitatorSearchBar.addEventListener('keyup', (e) => {
      let addFacilitatorTableSearch = document.getElementsByClassName('dataTable-input')[0];
      addFacilitatorTableSearch.value = facilitatorSearchBar.value;
      addFacilitatorTableSearch.dispatchEvent(new KeyboardEvent('keyup', {'key': e.key}))
    });
    let guestSearchBar = document.getElementById('addGuestSearchBar');
    guestSearchBar.addEventListener('keyup', (e) => {
      let addGuestTableSearch = document.getElementsByClassName('dataTable-input')[1];
      addGuestTableSearch.value = guestSearchBar.value;
      addGuestTableSearch.dispatchEvent(new KeyboardEvent('keyup', {'key': e.key}))
    });
  }

  addGuestJoiningOptionsEventListener() {

    let guestJoiningOptionsModal = document.getElementById('addGuestStep2Modal');
    guestJoiningOptionsModal.addEventListener('shown.bs.modal', function (event) {
    let button = event.relatedTarget
    let contactData = button.getAttribute('data-bs-guest')
    let data = JSON.parse(contactData);
    let joinByVideo = document.getElementById('radioInput4')
    let joinByDialOut = document.getElementById('radioInput3')

    document.getElementById('joiningMethodSubtitle').innerHTML = 'How will ' + data.name + ' join the call?';

    // Dont allow video if the user has no email
    if (data.email == null || data.email == "") {
        //this is horrible, but no worse than the rest.
        if (joinByVideo) {
          joinByVideo.disabled = true;
        }
          joinByDialOut.checked = true;
      }
      else {
        if (joinByVideo) {
          joinByVideo.disabled = false;
        }
      }
        
      

      console.table(data)
      document.getElementById('addGuest').setAttribute('data-value', contactData)
      document.getElementById('radioInput3').focus();
    })
  }

  addFacilitatorJoiningOptionsEventListener() {
    let facilitatorJoiningOptionsModal = document.getElementById('addFacilitatorStep2Modal');
    facilitatorJoiningOptionsModal.addEventListener('shown.bs.modal', function (event) {
      let button = event.relatedTarget
      let contactData = button.getAttribute('data-bs-facilitator')
      let data = JSON.parse(contactData);
  
      document.getElementById('joiningMethodSubtitle').innerHTML = 'How will ' + data.name + ' join the call?';
      document.getElementById('addFacilitator').setAttribute('data-value', contactData)
  
      // Shift focus to the first radio button in the modal
      document.getElementById('facInput1').focus();
    })
  }

  setContactsAndFacilitator(){
    this.setHiddenContactsField();
    this.contactListTarget.innerHTML = contactTemplate(this.contacts, 'scheduled--new');
    this.facilitatorListTarget.innerHTML = facilitatorTemplate(this.facilitators, 'scheduled--new')
    this.cache_scheduled_session.facilitators = this.facilitators;
    this.cache_scheduled_session.contacts = this.contacts;
    sessionStorage.setItem('cache_scheduled_session', JSON.stringify(this.cache_scheduled_session));
    this.contacts.forEach ((att) => {
      this.setAddButton(att.contact_id, false)
    });
    this.facilitators.forEach ((att) => {
      this.setAddButton(att.contact_id, false)
    });
  }

  setAddButton(contact_id, activate){
    let contactAddButton = document.getElementById(`contactAddButton${contact_id}`) || document.getElementById(`facilitatorAddButton${contact_id}`)
    if (contactAddButton) {
      contactAddButton.innerHTML = activate ? '<i class="fas fa-plus me-1"></i> Add' : 'Added'
      contactAddButton.disabled = activate ? false : true
      if (!activate) {
        contactAddButton.setAttribute('aria-hidden', 'true');
      }
    }
  }

  cacheScheduledSession(){
    this.cache_scheduled_session.title = this.titleTarget.value;
    this.cache_scheduled_session.start_date = this.startDateTarget.value;
    this.cache_scheduled_session.start_time = this.timePickerTarget.value;
    this.cache_scheduled_session.duration = this.durationTarget.value;
    this.cache_scheduled_session.frequency = this.frequencyTarget.value;
    sessionStorage.setItem('cache_scheduled_session', JSON.stringify(this.cache_scheduled_session));
  }

  setCachedFormValues(){
    if (this.cache_scheduled_session.title) { this.titleTarget.value = this.cache_scheduled_session.title }
    if (this.cache_scheduled_session.start_date) { this.startDateTarget.value = this.cache_scheduled_session.start_date }
    if (this.cache_scheduled_session.start_time) { this.timePickerTarget.value = this.cache_scheduled_session.start_time }
    if (this.cache_scheduled_session.duration) { this.durationTarget.value = this.cache_scheduled_session.duration }
    this.setFrequencyOptions();
    if (this.cache_scheduled_session.frequency) { this.frequencyTarget.value = this.cache_scheduled_session.frequency }
  }

  addContact(event) {
    let contact = JSON.parse(event.currentTarget.dataset.value)
    contact.dialout = document.getElementById('radioInput1').checked;
    let joinPrefs = document.getElementsByName('joining_preference');
    let joinPref;
    for (let i = 0; i < joinPrefs.length; i++) {
      if (joinPrefs[i].checked) {
        joinPref = joinPrefs[i].value;
      }
    }
    contact.joining_preference = joinPref;
    this.contacts.push(contact),
    document.getElementById('closeContactJoiningModal').click();
    document.getElementById('closeContactModal').click();
    document.getElementById('addContactModalLaunch').focus();
    this.setContactsAndFacilitator();
  }

  removeContact(event) {
    let index = parseInt(event.currentTarget.dataset.guestKey);
    let contact_id = this.contacts[index].contact_id;
    this.setAddButton(contact_id, true)
    this.contacts.splice(index, 1);
    this.setContactsAndFacilitator();
  }

  addFacilitator(event) {

    let facilitator = JSON.parse(event.currentTarget.dataset.value);
    let joinPrefs = document.getElementsByName('facilitator_joining_preference');
    let joinPref;
    for (let i = 0; i < joinPrefs.length; i++) {
      if (joinPrefs[i].checked) {
        joinPref = joinPrefs[i].value;
      }
    }
    facilitator.joining_preference = joinPref;
    facilitator.facilitator = true;
    this.facilitators.push(facilitator)
    document.getElementById('closeFacilitatorJoiningModal').click();
    document.getElementById('closeFacilitatorModal').click();

    document.getElementById('addFacilitatorModalLaunch').focus();
    this.setContactsAndFacilitator();
  }

  removeFacilitator(event) {
    let index = parseInt(event.currentTarget.dataset.guestKey);
    let contact_id = this.facilitators[index].contact_id;
    this.setAddButton(contact_id, true)
    this.facilitators.splice(index, 1);
    this.setContactsAndFacilitator();
  }

  setHiddenContactsField() {
    let contacts = this.contacts.concat(this.facilitators)
    this.contactsTarget.value = JSON.stringify(contacts)
  }

  createScheduledSessionForm(){
    let self = this;
    return FormValidation.formValidation(
      document.getElementById('createScheduledSessionForm'),
      {
        fields: {
          title: {
            selector: '[name="scheduled_session_form[summary]"]',
            validators: {
              notEmpty: {
                trim: true,
                message: 'Title is required'
              },
              stringLength: {
                max: 255,
                message: 'Title must be less than 255 characters'
              }
            }
          },
          startDate: {
            selector: '[name="scheduled_session_form[start_date]"]',
            validators: {
              notEmpty: {
                message: 'Start date is required'
              },
              callback: {
                callback: function() {
                  return {
                    valid: self.isStartTimeInFuture(),
                    message: 'Start date and time must be in the future'
                  }
                }
              }
            }
          },
          startTime: {
            selector: '[name="scheduled_session_form[start_time]"]',
            validators: {
              notEmpty: {
                message: 'Start time is required'
              },
              callback: {
                callback: function() {
                  return {
                    valid: self.isStartTimeInFuture(),
                    message: 'Start date and time must be in the future'
                  }
                }
              }
            }
          },
          duration: {
            selector: '[name="scheduled_session_form[duration]"]',
            validators: {
              notEmpty: {
                message: 'Duration is required'
              },
            }
          },
          frequency: {
            selector: '[name="scheduled_session_form[frequency]"]',
            validators: {
              notEmpty: {
                message: 'Frequency is required'
              }
            }
          }
        },
        plugins: {
          bootstrap5: new Bootstrap5({
            rowSelector: '.g-5'
          }),
          autoFocus: new AutoFocus(),
          submitButton: new FormValidation.plugins.SubmitButton(),
          aria: new FormValidation.plugins.Aria(),
        },
      }
    )
  }

  submitScheduledSession() {
    document.getElementById("createScheduledSessionSubmit").disabled = true;
    this.createScheduledSessionForm.validate().then(function (status) {
      if (status == 'Valid') {
        sessionStorage.removeItem('cache_scheduled_session');
        document.getElementById("createScheduledSessionForm").submit();
      } else {
        document.getElementById("createScheduledSessionSubmit").disabled = false;
      }
    });
  }

  isStartTimeInFuture(){
    let [year, month, day] = this.startDateTarget.value.split('-').map(x => parseInt(x));
    let [hour, minute] = this.timePickerTarget.value.split(':');
    let selectedTime = new moment.tz(new Date(year, month - 1, day, Number(hour)+1, minute), this.timezone).toDate()
    let currentTime = new moment.tz(this.timezone).toDate();
    return selectedTime > currentTime
  }

  setModalInputsAutofocus(){
    let facilitatorModal = document.getElementById('addFacilitatorModal')
    let contactModal = document.getElementById('addContactModal')
    facilitatorModal.addEventListener('shown.bs.modal', function (event) {
      event.target.querySelector("[autofocus]").focus();
    })
    contactModal.addEventListener('shown.bs.modal', function (event) {
      event.target.querySelector("[autofocus]").focus();
    })
  }

  setTimePickerOptions(){
    const roundToHour = (time) => {
      let [hour, minute] = time.split(':');
      let newHour = (parseInt(hour) + 1).toString();
      newHour = newHour == "24" ? "00" : padHourString(newHour);
      return `${newHour}:00`;
    }
    const padHourString = (hour) => {
      return hour.length == 1 ? `0${hour}` : hour;
    }

    const startHour = 0;
    const endHour = 24;
    let sessionTime;
    let times;

    let intervals = Array.from({
      length: endHour - startHour
      }, (_v, index) => {
        return [0,15,30,45].map((interval) => {
          return moment({
            hour: index,
            minute: interval
          })
          .add(startHour, 'hours')
          .format('HH:mm')
        })
    }).flat()


    times = intervals;
    sessionTime = roundToHour(new moment.tz(new Date, this.timezone).format("HH:mm"));
    let options = times.map ((time) => {
      return `<option value=${time}>${time}</option>`
    })
    this.timePickerTarget.innerHTML = options.join('');
    this.timePickerTarget.value = sessionTime;
  }

  setFrequencyOptions(){
    [5].forEach((element) => {this.frequencyTarget.remove(element)});
    let startDate = new Date(this.startDateTarget.value);
    if (startDate) {
      // nth named day of the month
      let nthWeekdayText = getWeekOfTheMonth(startDate);
      // let nthWeekdaySelectText = `${nthWeekdayText} of each month`
      let nthWeekdayRule = RRule.fromText(`Every month on the ${nthWeekdayText}`).toString().split("RRULE:")[1];

      [[nthWeekdayRule, "Every month"]].forEach((element) => {
        this.frequencyTarget.add(new Option(element[1], element[0]));
      });
    }
  }

}
